export default __webpack_public_path__ + "static/media/play.a533839b.png";